import { IPhotoDetails } from '@/app/models/photo'
import { GalleryService } from '@/app/services/GalleryService'
import { ProjectsService } from '@/app/services/ProjectsService'
import { layoutActions } from '@Techedge/digitalportal-shared'
import { SAVE_PICTURE_REDUCER_NAMESPACE } from '../reducers/save-picture'

export const SavePictureActions = {
    SHOW_TOAST_DOWNLOAD_SUCCESS: 'SHOW_TOAST_DOWNLOAD_SUCCESS',
    SHOW_TOAST_DOWNLOAD_FAILURE: 'SHOW_TOAST_DOWNLOAD_FAILURE',
    SHOW_TOAST_ACTION_FAILURE: 'SHOW_TOAST_ACTION_FAILURE',
    SET_PHOTO_DETAILS: 'SET_PHOTO_DETAILS',
    // CTA ACTIONS
    DOWNLOAD: 'SAVE_PICTURE_DOWNLOAD',
    ADD_TO_PACKAGE: 'SAVE_PICTURE_ADD_TO_PACKAGE',
    ADD_TO_ALBUM: 'SAVE_PICTURE_ADD_TO_ALBUM',
    DELETE_FROM_PICSTORE: 'SAVE_PICTURE_DELETE_FROM_PICSTORE',
    SEND_IN_APPROVAL: 'SAVE_PICTURE_SEND_IN_APPROVAL',
    STOP: 'SAVE_PICTURE_STOP',
    GO: 'SAVE_PICTURE_GO',
    PUBLISH: 'SAVE_PICTURE_PUBLISH',
    RETAKE_PHOTO: 'RETAKE_PHOTO',
    SAVE_AND_PUBLISH: 'SAVE_AND_PUBLISH',
    SAVE_AND_SEND_IN_APPROVAL: 'SAVE_AND_SEND_IN_APPROVAL',
    SAVE: 'SAVE',

    SET_PHOTO_TAG_LIST: `${SAVE_PICTURE_REDUCER_NAMESPACE}_SET_PHOTO_TAG_LIST`,
}

export const showToastDownloadError = () => {
    return {
        type: SavePictureActions.SHOW_TOAST_DOWNLOAD_FAILURE,
        toastList: [{ title: 'Error', text: 'Cannot perform download' }],
    }
}

export const showToastDownloadSuccess = () => {
    return {
        type: SavePictureActions.SHOW_TOAST_DOWNLOAD_SUCCESS,
        toastList: [{ title: 'Success', text: 'Succesfully downloaded!' }],
    }
}
export const showToastSavePictureSuccess = () => {
    return {
        type: SavePictureActions.SHOW_TOAST_DOWNLOAD_SUCCESS,
        toastList: [{ title: 'Success', text: 'Operation done!' }],
    }
}
export const showToastActionError = (error) => {
    return {
        type: SavePictureActions.SHOW_TOAST_ACTION_FAILURE,
        toastList: [{ text: error }],
    }
}
export const setPhotoDetials = (details: IPhotoDetails) => {
    return {
        type: SavePictureActions.SET_PHOTO_DETAILS,
        payload: details,
    }
}

export const approvePhoto = (attachmentIds: string[]) => async (dispatch: any) => {
    dispatch(layoutActions.setModals({ props: { loading: true } }))
    ProjectsService.ApprovePhoto(attachmentIds)
        .then(() => {
            dispatch(getPhotoDetails(attachmentIds[0]))
            dispatch(showToastSavePictureSuccess())
        })
        .catch((error) => dispatch(showToastActionError(error?.response?.data?.message)))
        .finally(() => dispatch(layoutActions.setModals({ props: { loading: false } })))
}
export const rejectPhoto = (attachmentIds: string[]) => async (dispatch: any) => {
    dispatch(layoutActions.setModals({ props: { loading: true } }))
    ProjectsService.RejectPhoto(attachmentIds)
        .then(() => {
            dispatch(getPhotoDetails(attachmentIds[0]))
            dispatch(showToastSavePictureSuccess())
        })
        .catch((error) => dispatch(showToastActionError(error?.response?.data?.message)))
        .finally(() => dispatch(layoutActions.setModals({ props: { loading: false } })))
}
export const publishPhoto = (attachmentIds: string[]) => async (dispatch: any) => {
    dispatch(layoutActions.setModals({ props: { loading: true } }))
    ProjectsService.PublishPhoto(attachmentIds)
        .then(() => {
            dispatch(getPhotoDetails(attachmentIds[0]))
            dispatch(showToastSavePictureSuccess())
        })
        .catch((error) => dispatch(showToastActionError(error?.response?.data?.message)))
        .finally(() => dispatch(layoutActions.setModals({ props: { loading: false } })))
}
export const sendInApprovalPhoto = (attachmentIds: string[]) => async (dispatch: any) => {
    dispatch(layoutActions.setModals({ props: { loading: true } }))
    ProjectsService.SendInApprovalPhoto(attachmentIds)
        .then(() => {
            dispatch(getPhotoDetails(attachmentIds[0]))
            dispatch(showToastSavePictureSuccess())
        })
        .catch((error) => dispatch(showToastActionError(error?.response?.data?.message)))
        .finally(() => dispatch(layoutActions.setModals({ props: { loading: false } })))
}
export const getPhotoDetails = (id: string) => async (dispatch: any) => {
    dispatch(layoutActions.setModals({ props: { loading: true } }))
    GalleryService.PhotoDetails(id)
        .then((res) => {
            dispatch(setPhotoDetials(res.data?.attachment))
        })
        .catch((error) => dispatch(showToastActionError(error?.response?.data?.message)))
        .finally(() => dispatch(layoutActions.setModals({ props: { loading: false } })))
}

export const addPhotosToExistingAlbum =
    (albumId: string, attachmentIds: string[]) => async (dispatch: any) => {
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        GalleryService.AddPhotosToAlbum(albumId, attachmentIds)
            .then(() => {
                dispatch(showToastSavePictureSuccess())
            })
            .catch((error) => dispatch(showToastActionError(error?.response?.data?.message)))
            .finally(() => dispatch(layoutActions.setModals({ props: { loading: false } })))
    }
export const deletePhoto =
    (attachmentIds: string[], callback: () => void) => async (dispatch: any) => {
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ProjectsService.DeletePhoto(attachmentIds)
            .then(() => {
                dispatch(showToastSavePictureSuccess())
                callback()
            })
            .catch((error) => dispatch(showToastActionError(error?.response?.data?.message)))
            .finally(() =>
                dispatch(
                    layoutActions.setModals({ props: { loading: false, reloadParentData: true } })
                )
            )
    }
export const updatePhotoTagList =
    (
        params: { attachmentId: string; tags: { name: string; x: number; y: number }[] },
        callback: () => void
    ) =>
    async (dispatch: any) => {
        GalleryService.updatePhotoTagList(params).then(() => {
            dispatch(getPhotoDetails(params.attachmentId))
            callback()
        })
    }
